import React from 'react';
import { Link } from 'react-router-dom';
import { profile } from '../data/profile';
import useSectionNavigation from '../hooks/useSectionNavigation';
import './footer.css';

export default function Footer() {
  const navigateToSection = useSectionNavigation();
  return <footer className="footer section-shell">
    <div className="footer__top" data-reveal><div><span className="eyebrow">CURIOUS BY NATURE. CREATIVE BY DESIGN.</span><p>Based in New Cairo, Egypt.<br />Creating with a wider world in mind.</p></div>
      <nav aria-label="Footer navigation"><Link to="/">Home</Link><Link to="/projects">Projects</Link><Link to="/about">About me</Link><Link to="/#services">Services</Link></nav>
      <nav aria-label="Social links"><a href={profile.behance} target="_blank" rel="noreferrer">Behance ↗︎</a><a href={profile.linkedin} target="_blank" rel="noreferrer">LinkedIn ↗︎</a><a href={profile.cv} target="_blank" rel="noreferrer">View CV ↗︎</a><a href={`mailto:${profile.email}`}>Email ↗︎</a></nav>
    </div>
    <Link className="footer__wordmark" to="/" aria-label="Zeina Tamer home" data-reveal>ZEINA TAMER<span aria-hidden="true">✳︎</span></Link>
    <div className="footer__bottom"><span>© {new Date().getFullYear()} Zeina Tamer</span><span>DESIGNED WITH INTENTION.</span><a href="#top" onClick={(event) => { event.preventDefault(); navigateToSection('#top'); }}>Back to top ↑︎</a></div>
  </footer>;
}
